import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, createVNode, unref, toDisplayString, createCommentVNode } from "vue";
import StaffPickBadge from "../StaffPickBadge/StaffPickBadge2.mjs";
const _hoisted_1 = {
  class: "staff-testimonial"
};
const _hoisted_2 = {
  class: "staff-testimonial__testimonial-container"
};
const _hoisted_3 = {
  class: "staff-testimonial__text",
  "data-ui": "staff-testimonial-text"
};
const _hoisted_4 = {
  class: "staff-testimonial__author-info"
};
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = {
  class: "staff-testimonial__author-details"
};
const _hoisted_7 = {
  "data-ui": "staff-testimonial-staff-heading"
};
const _hoisted_8 = {
  "data-ui": "staff-testimonial-state"
};
const _hoisted_9 = {
  key: 0,
  "data-ui": "staff-testimonial-activity-timeline"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "StaffTestimonialAlternate",
  props: {
    name: {},
    state: {},
    activity: {},
    year: {},
    staffImg: {},
    text: {}
  },
  setup(__props) {
    const props = __props;
    const staffDetails = computed(() => ({
      name: props.name,
      state: props.state,
      activity: props.activity,
      year: props.year,
      staffImg: props.staffImg,
      text: `“${props.text}”`
    }));
    const showYearAndActivityLine = computed(() => props.activity && props.year);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", _hoisted_1, [createElementVNode("section", _hoisted_2, [createVNode(unref(StaffPickBadge), {
        class: "staff-testimonial__badge"
      }), _cache[0] || (_cache[0] = createElementVNode("h2", {
        "data-ui": "staff-testimonial-heading"
      }, " Tested and recommended by REI staff ", -1)), createElementVNode("p", _hoisted_3, toDisplayString(staffDetails.value.text), 1), createElementVNode("div", _hoisted_4, [staffDetails.value.staffImg ? (openBlock(), createElementBlock("img", {
        key: 0,
        class: "staff-testimonial__author-img",
        "data-ui": "staff-testimonial-staff-img",
        src: staffDetails.value.staffImg,
        alt: `Staff member ${staffDetails.value.name}`
      }, null, 8, _hoisted_5)) : createCommentVNode("", true), createElementVNode("div", _hoisted_6, [createElementVNode("h3", _hoisted_7, toDisplayString(staffDetails.value.name), 1), createElementVNode("p", _hoisted_8, " REI Staff - " + toDisplayString(staffDetails.value.state), 1), showYearAndActivityLine.value ? (openBlock(), createElementBlock("p", _hoisted_9, toDisplayString(staffDetails.value.activity) + " since " + toDisplayString(staffDetails.value.year), 1)) : createCommentVNode("", true)])])])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=StaffTestimonialAlternate2.mjs.map
